import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { endpointHelpers } from '../../../features/serverBots/endpointHelpers'

export function useIsBotNameLoading(botId: string) {
  return useSelector<RootState, boolean>(state => {
    return !!endpointHelpers.deleteBot.fixedKeySelector({ botId })(state)?.isLoading
  })
}
